export const comparisonData = [
  {
    platform: "CSSBuy Spreadsheet",
    support: 5,
    speed: "Fast",
    qcEfficiency: "High",
    beginnerFriendly: "Yes",
  },
  {
    platform: "Kakobuy Spreadsheet",
    support: 4,
    speed: "Fast",
    qcEfficiency: "Medium",
    beginnerFriendly: "Yes",
  },
  {
    platform: "Superbuy Spreadsheet",
    support: 3,
    speed: "Medium",
    qcEfficiency: "High",
    beginnerFriendly: "Medium",
  },
  {
    platform: "Oopbuy Spreadsheet",
    support: 4,
    speed: "Fast",
    qcEfficiency: "High",
    beginnerFriendly: "Yes",
  },
];

export const statsData = [
  { value: "14", label: "Categories" },
  { value: "40%", label: "Savings" },
  { value: "10K+", label: "Users" },
  { value: "24/7", label: "Support" },
];